<template>
  <div class="news-item-container">
    <div class="row news-item-container-title">
      <div class="industry-title">
        <a v-if="!data.is_pdf" target="_blank" class="title" :href="data.url">{{data.title}}</a>
        <router-link @click.native="toPdfPage" class="title" v-else target="_blank" :to="{path: '/pdf-detail'}">
          <span>{{data.title}}</span>
        </router-link>
      </div>
      <div class="row date-source">
        <div class="date">{{data.date}}</div>
        <div class="source">{{data.source}}</div>
      </div>
    </div>
    <div class="row industry-tags">
      <div class="industry" v-for="(item, index) in data.themes" :key="index+'industry'">
        {{item}}
      </div>
      <!-- <div class="event" v-for="(item, index) in data.events" :key="index+'event'">
        {{item}}
      </div> -->
      <div class="emotional" :class="{'positive-tag': item==='正面', 'negative-tag': item==='负面'}" v-for="(item, index) in data.sentiments" :key="index+'emotional'">
        {{item}}
      </div>
      <!-- <div class="tag-name" :class="{positive: tag.type === 'positive', negative: tag.type === 'negative', neutral: tag.type === 'neutral'}"  v-for="(tag, index) in data.tags" :key="index+'tag-name'">
        {{tag.tagName}}
      </div> -->
    </div>
    <sn-news-dialog ref="snNewsDialog"></sn-news-dialog>
  </div>
</template>

<script>
import SnNewsDialog from '@/components/common/SnNewsDialog';
import localStorageHelper from '@/helpers/localStorageHelper';

export default {
  name: 'news-list-item',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    toPdfPage() {
      localStorageHelper.setItem('PDF_DETAIL_DATA', JSON.stringify(this.data));
    },
    onCheckDetailClick(id) {
      this.$refs.snNewsDialog.checkDetail(id);
    }
  },
  components: {
    SnNewsDialog
  }
};
</script>

<style lang="scss" scoped>
.news-item-container {
  padding: 16px 0;
  box-shadow: inset 0px -1px 0px 0px #f7f7fa;
  .news-item-container-title {
    justify-content: space-between;
    margin-bottom: 12px;
    line-height: 22px;
    .industry-title {
      width: 750px;
      .title {
        display: inline-block;
        min-height: 22px;
        color: #171f46;
        font-size: 16px;
        font-weight: 500;
        text-decoration: none;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .date-source {
      margin-left: 20px;
      color: #747990;
      font-size: 12px;
      .source {
        margin-left: 16px;
        max-width: 108px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .industry-tags {
    .industry {
      margin-right: 10px;
      padding: 0 8px;
      color: #45a8cc;
      border: 1px solid #45a8cc;
      border-radius: 2px;
      font-size: 12px;
    }
    .event {
      margin-right: 10px;
      padding: 0 8px;
      border: 1px solid #e8e8e8;
      border-radius: 2px;
      color: #464d6c;
      font-size: 12px;
    }
    .emotional {
      margin-right: 10px;
      padding: 0 8px;
      border: 1px solid #e8e8e8;
      border-radius: 2px;
      color: #464d6c;
      font-size: 12px;
    }
    .positive-tag {
      color: #dc5057 !important;
      border: 1px solid #dc5057;
    }
    .negative-tag {
      color: #31af84;
      border: 1px solid #31af84;
    }
  }
  .tag-name {
    margin-right: 10px;
    font-size: 12px;
  }
  .positive {
    color: #ff5b65;
  }
  .negative {
    color: #54cea4;
  }
  .neutral {
    color: #ffffff;
  }
}
/deep/.detail-dialog {
  .detail-dialog-header {
    padding: 32px 32px 24px;
    min-height: 110px;
    width: 100%;
    box-shadow: inset 0px -1px 0px 0px#4f4e55;
    .title {
      margin-bottom: 10px;
      color: #ffffff;
      font-size: 20px;
      font-weight: 500;
    }
    .dialog-date-source {
      justify-content: space-between;
      color: rgba(255, 255, 255, 0.7);
      font-size: 12px;
      font-weight: 500;
      .source {
        margin-left: 16px;
      }
    }
  }
  .detail-dialog-content {
    padding: 24px 32px;
    height: 496px;
    overflow: auto;
    color: #ffffff;
    font-size:14px;
    line-height: 22px;
    box-shadow: inset 0px -1px 0px 0px#4f4e55;
  }
  .detail-dialog-footer {
    padding: 16px 32px;
    .url {
      color: #45a8cc;
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
    }
    .warning {
      margin-top: 4px;
      color: rgba(255, 255, 255, 0.7);
      font-size: 12px;
    }
  }
  .el-dialog {
    background-color: #333138;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      min-height: 680px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0px;
    }
  }
}
/deep/{
  .el-switch__core {
    width: 34px !important;
  }
  .el-switch__core:after {
    top: 3px;
    left: 3px;
    width: 12px;
    height: 12px;
    background-color: #e4e4e4;
  }
  .el-switch.is-checked .el-switch__core::after {
    margin-left: -14px;
  }
}
</style>


